import React, { useState, Fragment } from 'react'
import { FormField, Label, TextInput } from '../../ui/form';

import { CheckoutSettings } from '../request/apis'
import { tips } from '../locales'
import storage from '../utils/storage'

const PaymentsAdditionalTextField = (props: { checkoutSettings: CheckoutSettings }) => {

  const {
    checkoutSettings: {
      checkoutPaymentAdditionalExtraFields,
      checkoutPaymentAdditionalExtraFieldsRequired,
    },
  } = props

  const [paymentsAdditionalTextFieldValue, setPaymentsAdditionalTextFieldValue] = useState(storage.B3PaymentsAdditionalTextFieldValue.getValue() || '')

  const handleAdditionalTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setPaymentsAdditionalTextFieldValue(value)
    value ? storage.B3PaymentsAdditionalTextFieldValue.setValue(value) : storage.B3PaymentsAdditionalTextFieldValue.removeValue()
  }

  const renderField = () => (
    <Fragment>
      <Label
        htmlFor="additional-text-field"
        className="form-legend optimizedCheckout-contentSecondary"
        style={{ cursor: 'pointer' }}
      >
        {checkoutPaymentAdditionalExtraFields?.value}
        {
          +checkoutPaymentAdditionalExtraFieldsRequired.value === 0 &&
          <small className="optimizedCheckout-contentSecondary">
            <span>{tips['b3.label.optional']}</span>
          </small>
        }
        <span style={{ color: '#d03137' }}> *</span>
      </Label>

      <TextInput
        id="additional-text-field"
        type="text"
        value={paymentsAdditionalTextFieldValue}
        onChange={handleAdditionalTextFieldChange}
        maxLength={ 20 }
      />
    </Fragment>
  )

  return (
    <div className="b3-additional-text-field">
      <FormField input={renderField} name="PaymentsAdditionalTextField" />
    </div>
  )
}

export default PaymentsAdditionalTextField
